import { Component, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { MessageBook } from '@model/webFeeder/message-book.model';
import { AuthServer } from '@services/auth-server.service';
import { BilletOrderModalService } from '@services/billet-order-modal.service';
import { BookService } from '@services/webFeeder/sckt-book.service';
import { AppUtils } from '@utils/app.utils';
import { Subscription , of } from 'rxjs';

@Component({
  selector: 'app-book-detail',
  templateUrl: './book-detail.component.html'
})
export class BookDetailComponent implements OnDestroy, OnChanges {

  @Input() symbol: string;
  @Input() subscribeBook = false;
  @Input() tabIndex: number;
  @Input() componentName: string;
  private subscriptionBook: Subscription;
  rowOffersData: any[];
  loadingDetailBook: boolean;
  valueBuy: number;
  valueSell: number;
  @Input() tickSize = 2;
  tooltiphover = false;
  hasSubscribeBook = false;
  oldSymbol: string;

  auctionHammer: any;

  constructor(
    private _bookService: BookService,
    private _authServer: AuthServer,
    private _billetOrderModalService: BilletOrderModalService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.componentName && changes.componentName.currentValue) {
      this.componentName = changes.componentName.currentValue + ' DETALHADO';
    }
    if (changes.subscribeBook && changes.subscribeBook.previousValue !== changes.subscribeBook.currentValue) {
      if (!changes.subscribeBook.currentValue && this.hasSubscribeBook) {
        this.rowOffersData = [];
        this.unsubscriptionScktBook(this.oldSymbol);
        this.hasSubscribeBook = false;
        this.oldSymbol = null;
      }
      if (changes.subscribeBook.currentValue && this.symbol && !this.hasSubscribeBook) {
        this.subscriptionScktBook(this.symbol);
        this.hasSubscribeBook = true;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptionBook) {
      this.unsubscriptionScktBook(this.symbol);
    }
  }

  private subscriptionScktBook(symbol: string) {
    this.loadingDetailBook = true;
    this._bookService.subscribeBook(symbol, this.componentName);
    this.oldSymbol = symbol;
    this.subscriptionBook = this._bookService.messagesBook
      .subscribe((msg: MessageBook) => {
        if (msg !== undefined && msg.symbol != null && msg.symbol === this.symbol) {
          this.rowOffersData = [];
          let broker_purchase_short = '';
          let broker_sale_short = '';
          this.valueBuy = 0;
          this.valueSell = 0;
          if (!msg.buy && !msg.sell) {
            return;
          }
          for (let i = 0; i < 15; i++) {
            // buy
            let broker_id = '';
            let broker_purchase = '';
            let qty_purchase = '';
            let purchase = '';
            // sell
            let sale = '';
            let qty_sale = '';
            let broker_sale_id = '';
            let broker_sale = '';

            if (msg.buy && msg.buy.length > i) {
              this.valueBuy = this.valueBuy + msg.buy[i].Q;
            }
            if (msg.sell && msg.sell.length > i) {
              this.valueSell = this.valueSell + msg.sell[i].Q;
            }
            if (msg.buy && msg.buy.length > i) {
              broker_id = msg.buy[i].C || '-';
              broker_purchase = this._authServer.iQuote.getPlayerName(msg.buy[i].C);
              qty_purchase = msg.buy[i].FQ;
              purchase = AppUtils.convertNumberToCurrency(msg.buy[i].P, this.tickSize);
              if (broker_purchase && broker_purchase.length > 11) {
                broker_purchase_short = broker_purchase.substr(0, 10) + '...';
              } else {
                broker_purchase_short = broker_purchase;
              }
            } else {
              broker_purchase_short = null;
            }

            if (msg.sell && msg.sell.length > i) {
              sale = AppUtils.convertNumberToCurrency(
                msg.sell[i].P,
                this.tickSize
              );
              qty_sale = msg.sell[i].FQ;
              broker_sale_id = msg.sell[i].C || '-';
              broker_sale = this._authServer.iQuote.getPlayerName(msg.sell[i].C);
              if (broker_sale && broker_sale.length > 11) {
                broker_sale_short = broker_sale.substr(0, 10) + '...';
              } else {
                broker_sale_short = broker_sale;
              }
            } else {
              broker_sale_short = null;
            }
            if (broker_id || broker_sale_id) {
              this.rowOffersData.push({
                broker_id: broker_id,
                broker_purchase: broker_purchase,
                qty_purchase: qty_purchase,
                purchase: purchase,
                sale: sale,
                qty_sale: qty_sale,
                broker_sale_id: broker_sale_id,
                broker_sale: broker_sale,
                broker_purchase_short: broker_purchase_short,
                broker_sale_short: broker_sale_short
              });
            }
          }
          this.loadingDetailBook = false;
        }
      });
  }

  private unsubscriptionScktBook(symbol: string) {
    if (this._bookService) {
      this._bookService.unsubscribeBook(symbol, this.componentName);
      if (this.subscriptionBook) {
        this.subscriptionBook.unsubscribe();
      }
    }
  }

  openBillet(type: string, price: any) {
    if (type === 'buy') {
      this._billetOrderModalService.buySellOrder('buy', this.symbol || '', price || 0.0);
    } else {
      this._billetOrderModalService.buySellOrder('sell', this.symbol || '', price || 0.0);
    }
  }

  mouseEnterBrokerRow() {
    this.tooltiphover = true;
    setTimeout(() => {
      this.mouseLeaveBrokerRow();
    }, 8000);
  }

  mouseLeaveBrokerRow() {
    this.tooltiphover = false;
  }

}
